/**
 * Sanitize phone input: strip non-digits, remove leading +91/91/0 prefix
 * Shared across LeadForm, LeadsPage, etc.
 */
export const sanitizePhone = (raw) => {
    if (!raw) return "";
    // Remove all non-digit characters
    let digits = raw.replace(/\D/g, "");
    // Remove leading country code / zero
    if (digits.startsWith("91") && digits.length > 10) {
        digits = digits.slice(2);
    } else if (digits.startsWith("0") && digits.length > 10) {
        digits = digits.slice(1);
    }
    // Limit to 10 digits
    return digits.slice(0, 10);
};
